/* eslint-disable no-shadow */
/* eslint-disable camelcase */
import { createState, useState } from '@hookstate/core'
import { Persistence } from '@hookstate/persistence';
import { UserTypes } from '../config/enums';
import { LoginInfoState } from '../config/interfaces';

const initialState: LoginInfoState = {
  user_id: undefined,
  company_id: undefined,
  email_verified: false,
  user_type: UserTypes.PRODUCER,
  can_edit: false,
};

const loginState = createState(initialState);
loginState.attach(Persistence('loginInfo'));

export const setLoginUser = (loginInfo: LoginInfoState) => {
  loginState.set({
    ...initialState,
    user_id: loginInfo.user_id,
    company_id: loginInfo.company_id,
    email: loginInfo.email,
    email_verified: loginInfo.email_verified,
    first_name: loginInfo.first_name,
    last_name: loginInfo.last_name,
  });
};

export const setUserType = (userType: UserTypes) => {
  loginState.user_type.set(userType);
};

export const setEditing = (isProducer: boolean) => {
  loginState.can_edit.set(isProducer);
};

export const useLoginState = () => useState(loginState);
